import { KOCH_SWIPER_A11Y } from '../../scripts/swiper-defaults';

export function initPartnersSliders() {
    const sliders = document.querySelectorAll('[data-koch-partners-slider]');
    if (!sliders.length || typeof Swiper === 'undefined') {
        return;
    }

    sliders.forEach((slider) => {
        if (slider.swiper) {
            return;
        }

        const root = slider.closest('.koch-partners__slider') || slider;
        const prev = root.querySelector('.koch-partners__arrow--prev');
        const next = root.querySelector('.koch-partners__arrow--next');

        new Swiper(slider, {
            a11y: KOCH_SWIPER_A11Y,
            slidesPerView: 1,
            spaceBetween: 24,
            loop: true,
            watchOverflow: true,
            autoplay: {
                delay: 3500,
                disableOnInteraction: false,
                pauseOnMouseEnter: true,
            },
            navigation: {
                nextEl: next,
                prevEl: prev,
            },
            breakpoints: {
                576: { slidesPerView: 3 },
                992: { slidesPerView: 4 },
            },
        });
    });
}
